import { useRef } from 'react';
import { motion } from 'motion/react';

import { cn } from '@components/primitives/utilities';

import css from './Nodes.module.css';

export default function DiagramRequest({
  className,
  children,
  ease,
  duration = 3,
  delay = 0,
  repeatDelay = 0,
  encrypted = false,
  onArrive,
}) {
  const classes = cn(css.request, encrypted && css.encryptedRequest, className);
  const last = useRef(0);

  const handleUpdate = ({ offsetDistance }) => {
    const distance = parseFloat(offsetDistance);
    if (distance >= 99.5 && last.current < 99.5) onArrive?.();
    last.current = distance;
  };

  return (
    <motion.div
      className={classes}
      initial={{ offsetDistance: '0%' }}
      animate={{ offsetDistance: '100%' }}
      transition={{ duration, delay, repeatDelay, ease, repeat: Infinity }}
      onUpdate={handleUpdate}
      data-encrypted={true}
    >
      {children}
    </motion.div>
  );
}
